import React from "react";
import { useFieldArray } from "react-hook-form";
import Input from "../Input/Input";
import styles from "./AcademicActivites.module.css";

const ResearchPapers = ({ register, control, errors, disabled }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "researchPapers",
  });

  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        title: "",
        journalName: "",
        authors: "",
        indexingCategory: "",
        year: "",
        DOI: "",
      });
    }
  }, [fields, append]);

  return (
    <div>
      <div className={styles.heading}>
        <div>
          <h2>Publications</h2>

          <h2>
            1 . Research Papers (Scops / ABDC / Wos / UGC / Peer-Reviewed)
          </h2>
        </div>{" "}

      </div>
      {fields.map((item, idx) => (
        <div className={styles.grid3} key={item.id}>
          <Input
            label="Title"
            name={`researchPapers[${idx}].title`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Journal Name"
            name={`researchPapers[${idx}].journalName`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Authors"
            name={`researchPapers[${idx}].authors`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Indexing Category"
            name={`researchPapers[${idx}].indexingCategory`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Year"
            name={`researchPapers[${idx}].year`}
            register={register}
            errors={errors}
            year
            disabled={disabled}
          />
          <Input
            label="DOI/URL"
            name={`researchPapers[${idx}].DOI`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          {idx > 0 && !disabled && (
            <button
              type="button"
              className={styles.remove}
              onClick={() => remove(idx)}
            >
              X
            </button>
          )}
        </div>
      ))}

      <div className={styles.buttonOuter}>
        <div></div>
        {!disabled && (
          <button
            type="button"
            className={styles.button}
            onClick={() =>
              append({
                title: "",
                journalName: "",
                authors: "",
                indexingCategory: "",
                year: "",
                DOI: "",
              })
            }
          >
            + Add More
          </button>
        )}
      </div>
    </div>
  );
};

export default ResearchPapers;
